const schemaReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_SCHEMA":
      return Object.assign({}, state, {
        [action.name]: {
          sVersion: action.schema.sVersion,
          pkName: action.pkName,
          props: action.schema.props,
          httpGetParameters: action.schema.httpGetParameters,
          generalSchema: action.schema.generalSchema,
        },
      });
    case "PATCH_SCHEMA":
      return Object.assign({}, state, {
        [action.name]: {
          ...state[action.name],
          props: {
            ...state[action.name]?.props,
            ...action.schemaPatch.props,
          },
        },
      });
    case "DROP_SCHEMA":
      return {};
    default:
      return state;
  }
};

export default schemaReducer;
